import React from 'react'

import {
  Wrapper,
  ThumbnailWrapper,
  NameSkeleton,
} from './ListPublicationItem.styles'
import { PublicationThumbnailSkeleton } from '../PublicationThumbnail'

export const ListPublicationItemPlaceholder = () => {
  return (
    <Wrapper>
      <ThumbnailWrapper>
        <PublicationThumbnailSkeleton />
      </ThumbnailWrapper>
      <NameSkeleton />
    </Wrapper>
  )
}
